import { render, staticRenderFns } from "./Detallesperfil.vue?vue&type=template&id=b7f1f03c&scoped=true&"
import script from "./Detallesperfil.vue?vue&type=script&lang=js&"
export * from "./Detallesperfil.vue?vue&type=script&lang=js&"
import style0 from "./Detallesperfil.vue?vue&type=style&index=0&id=b7f1f03c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f1f03c",
  null
  
)

export default component.exports